module.exports = __webpack_public_path__ + "static/media/image3.78c6ca0e.jpeg";